export default __webpack_public_path__ + "static/media/web.c9a10b40.png";